export default __webpack_public_path__ + "static/media/Title.fbcb85c6.png";